import styles from '@components/components/CmsComponents/components/CmsQuizWidget/CmsQuizWidget.module.scss';
import Container from '@components/components/Container/Container';
import { emailRegex } from '@components/utils';
import { useAjax, useMedia, useTracking } from '@components/hooks';
import { Quiz } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import React, { useState, useEffect, useRef } from 'react';
import { useFormStore } from '@ariakit/react';

const CmsQuizWidget = ({
  backgroundColor,
  title,
  receiverEmail,
  isRaffle,
  questions,
  ...props
}) => {
  const topRef = useRef(null);
  const [step, setStep] = useState(0);
  const [score, setScore] = useState(0);
  const [result, setResult] = useState([]);
  const validateEmail = mail => emailRegex.test(mail);
  const track = useTracking();
  const [submitRaffleData] = useAjax('we_theme_submit_quiz_raffle');
  const [values, setValues] = useState({
    title,
    answer: [],
    anrede: '',
    vorname: '',
    nachname: '',
    email: '',
    telefon: '',
    accepted: false,
  });
  const form = useFormStore({ values, setValues });
  const isMobile = useMedia('(max-width: 767px)');
  const currentStep = isRaffle ? step : step + 1; // if it is not Raffle, it skips the intro

  form.useValidate(() => {
    if (!values.vorname) {
      form.setError('vorname', 'Vorname muss ausgefüllt sein.');
    }
    if (!values.nachname) {
      form.setError('nachname', 'Nachname muss ausgefüllt sein.');
    }
    if (!validateEmail(values.email)) {
      form.setError('email', 'Bitte überprüfen Sie Ihre Eingabe.');
    }
    if (!values.email) {
      form.setError('email', 'Email muss ausgefüllt sein.');
    }
    if (!values.telefon) {
      form.setError('telefon', 'Telefonnummer muss ausgefüllt sein.');
    }
    if (!values.accepted) {
      form.setError(
        'accepted',
        'Bitte akzeptieren Sie die Teilnahmebedingungen.',
      );
    }
  });

  form.useSubmit(async () => {
    try {
      const postValues = {
        title,
        score,
        result,
        receiverEmail,
        email: values.email,
        salutation: values.anrede,
        accepted: values.accepted,
        firstname: values.vorname,
        lastname: values.nachname,
        phone: values.telefon,
      };
      const formData = new FormData();

      Object.entries(postValues).forEach(([key, value]) => {
        if (typeof value === 'string') {
          formData.append(key, value);
          return;
        }

        formData.append(key, JSON.stringify(value));
      });

      const { data: response } = await submitRaffleData(formData);

      if (!response?.success) {
        throw new Error(response.data[0].message);
      }

      track({
        event: 'gewinnspiel teilgenommen',
        title: 'Danke für ihre Teilnahme',
      });
      setStep(prev => prev + 1);
    } catch (error) {
      /* empty */
    }
  });

  useEffect(() => {
    if (topRef.current && isMobile) {
      topRef.current.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }

    if (currentStep > 1 && currentStep <= questions.length) {
      track({
        event: 'quiz_steps',
        eventCategory: 'quiz',
        eventAction: `step${currentStep - 1}`,
        eventName: questions[currentStep - 2]?.questionTitle,
      });
      // if no raffle, raffel step is skipped
    } else if (currentStep - (isRaffle ? 1 : 2) === questions.length) {
      track({
        event: 'quiz teilgenommen',
        title: 'Danke für ihre Teilnahme',
      });
    }
  }, [step]);
  return (
    <Container
      className={classNames(styles.container, styles[backgroundColor], {
        [styles.hasBackground]: backgroundColor,
      })}
      ref={topRef}
      size="xlg"
    >
      <Quiz
        isMobile={isMobile}
        isRaffle={isRaffle}
        questions={questions}
        setResult={setResult}
        setScore={setScore}
        setStep={setStep}
        step={step}
        store={form}
        title={title}
        {...props}
      />
    </Container>
  );
};

export default CmsQuizWidget;
